import { render, staticRenderFns } from "./VideoEmbed.vue?vue&type=template&id=c34b227e&"
import script from "./VideoEmbed.vue?vue&type=script&lang=js&"
export * from "./VideoEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports